import { Dialog,  Grid, Button } from "@material-ui/core";
import { DocumentacionComprobante } from "../../../MesaEntrada/UI/Documentacion/DocumentacionComprobante";
import { MENU_TIPO_EXPEDIENTE } from "../../../../utils/constants";
export const ModalDocumentacionTramite = (props) =>{
    return (
        <Dialog
            fullWidth
            maxWidth={"md"}
            open={props.open}
        >
            <Grid style={{ overflowX: "auto", marginTop: '1rem', padding: '2rem' }}>
                <DocumentacionComprobante idExpediente={props.idExpediente}
                menuPrestadorRecepcion={MENU_TIPO_EXPEDIENTE.PRESTADOR}/>
            </Grid>
            <Grid style={{margin:'1rem'}}>
                <Button
                    variant="contained"
                    onClick={props.closeModalHandler}
                    color='primary'
                    style={{textAlign:'center', display:'flex', margin:'auto'}}
                >
                    Cerrar
                </Button>
            </Grid>
        </Dialog>
    )
};  